/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Principal from "conten/principal/Principal";

var authRoutes = [
  {
    path: "/admin-request",
    name: "Nueva solicitud",
    mini: "NS",
    component: Principal,
    layout: "/page"
  }
];
export default authRoutes;
